<template>
  <div class="c-searchServiceUsersCarousel">
    <ContentHeadline
      class="c-searchServiceUsersCarousel_headline"
      title-tag="h2"
      :title-text="title"
      :right-link="getShowMore()"
    />
    <CassetteCarousel
      class="c-searchServiceUsersCarousel_list"
      :slides-count="slidesCount"
      :pc-sizes="['FULL']"
    >
      <UserCassette
        v-for="(user, index) in users"
        class="c-searchServiceUsersCarousel_item"
        :key="`user-cassette-${user.userId}`"
        :user="user"
        :item-number="index"
        :is-simple="isSimple"
      />
      
    </CassetteCarousel>
  </div>
</template>

<script>
import ContentHeadline from '~/components/molecules/ContentHeadline'
import CassetteCarousel from '~/components/molecules/CassetteCarousel'
import UserCassette from '~/components/molecules/UserCassette'
import LinkRefProvider from '~/mixins/link-ref/LinkRefProvider'

const USERS_PER_SLIDE = 4

/** @type {import('vue').ComponentOptions} */
const SearchServiceUsersCarousel = {
  name: 'SearchServiceUsersCarousel',
  mixins: [LinkRefProvider],
  components: {
    UserCassette,
    ContentHeadline,
    CassetteCarousel
  },
  props: {
    users: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showMoreUrl: {
      type: String,
      default: null
    },
    /** 簡略表示 */
    isSimple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slidesCount() {
      return Math.ceil(this.users.length / USERS_PER_SLIDE)
    }
  },
  methods: {
    getShowMore() {
      if (this.showMoreUrl) {
        const refQuery = (/\?.+/.test(this.showMoreUrl) ? '&' : '?') + `ref=${this.linkRef}`
        return {
          text: `${this.title}をもっと見る`,
          link: this.showMoreUrl + refQuery
        }
      }
      return null
    }
  }
}
export default SearchServiceUsersCarousel
</script>

<style lang="scss" scoped>
.c-searchServiceUsersCarousel {
  &_list {
    margin-top: 16px;
    /deep/ {
      .c-cassetteCarousel_inner {
        margin-left: 0;
      }
    }
  }
  &_item {
    flex-shrink: 0;
    margin-right: 10px;
  }
}
@media (max-width: breakpoint(Search, M)) {
  .c-searchServiceUsersCarousel {
    &_headline {
      padding: 0 12px;
    }
    &_list {
      margin-top: 8px;
      /deep/ {
        .c-cassetteCarousel_inner {
          margin-left: 12px;
        }
      }
    }
  }
}
</style>
